import { render, staticRenderFns } from "./CompaniesByGroup.vue?vue&type=template&id=cd95c59e&scoped=true"
import script from "./CompaniesByGroup.vue?vue&type=script&lang=js"
export * from "./CompaniesByGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd95c59e",
  null
  
)

export default component.exports